import PropTypes from 'prop-types';
import {useHistory} from 'react-router';
import {useTheme} from '@mui/material/styles';
import {Stack, Typography} from '@mui/material';
import {Button, BackgroundPaper} from 'mui-core';
import {noResultsIcon} from 'sharedResources/assets/images';

const NoResults = ({
  navPath,
  navTitle,
  subTitle,
  onButtonClick,
  hideNavigationButton = false,
  title = 'Oops! No Results Found',
}) => {
  const theme = useTheme();
  const history = useHistory();
  const onNavigation = () => {
    navPath && history.push(navPath);
    onButtonClick && onButtonClick();
  };

  return (
    <BackgroundPaper
      p={2}
      borderRadius={4}
      background={{
        dark: theme.palette.darkGray.main,
        light: theme.palette.grayLight.main,
      }}>
      <Stack alignItems="center" spacing={2} borderRadius={2}>
        <img
          width={80}
          height={80}
          src={noResultsIcon}
          alt="no search results"
        />
        {title && (
          <Typography
            component="p"
            color="text.primary"
            variant="text-md-regular">
            {title}
          </Typography>
        )}
        {subTitle && (
          <Typography
            component="p"
            textAlign="center"
            color="text.primary"
            variant="text-md-regular">
            {subTitle}
          </Typography>
        )}
        {!hideNavigationButton && (navPath || onButtonClick) && navTitle && (
          <Button size="large" variant="contained" onClick={onNavigation}>
            {navTitle}
          </Button>
        )}
      </Stack>
    </BackgroundPaper>
  );
};

NoResults.prototype = {
  title: PropTypes.string,
  navPath: PropTypes.string,
  navTitle: PropTypes.string,
  subTitle: PropTypes.string,
  onButtonClick: PropTypes.func,
  hideNavigationButton: PropTypes.bool,
};

export default NoResults;
